import type { ClienteAtual, SessaoCliente } from '@mymaxx/shared';
import { create } from 'zustand';

/**
 * Sessão do cliente. O access token fica só em memória; o refresh vive num cookie httpOnly
 * enviado apenas para /v1/auth/cliente/*. Ao abrir o site, `restaurar()` troca o cookie por
 * um access token novo — por isso o cliente continua logado por 30 dias sem guardar nada sensível.
 */
interface EstadoSessao {
  accessToken: string | null;
  cliente: ClienteAtual | null;
  restaurando: boolean;
  definir: (sessao: SessaoCliente) => void;
  /** Troca só os dados da pessoa, sem mexer no token (foto, nome, nota). */
  definirCliente: (cliente: ClienteAtual) => void;
  limpar: () => void;
  concluirRestauracao: () => void;
}

export const useSessao = create<EstadoSessao>((set) => ({
  accessToken: null,
  cliente: null,
  restaurando: true,
  definir: (s) => set({ accessToken: s.accessToken, cliente: s.cliente, restaurando: false }),
  definirCliente: (cliente) => set({ cliente }),
  limpar: () => set({ accessToken: null, cliente: null, restaurando: false }),
  concluirRestauracao: () => set({ restaurando: false }),
}));

export const lerAccessToken = () => useSessao.getState().accessToken;
